module.exports = "/packs/images/svg/facilities/bicycle~bc01709f9fbd43bfff7e4f9f1f04386f.svg";